module.exports = {"pathContext":{"slug":"/404/","langKey":"ja"}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/404.json
// module id = 786
// module chunks = 254022195166212